import { Autocomplete, Box, Stack, TextField, Typography } from "@mui/material";
import { formatTitle } from "../utils";
import { ColorsConstants } from "../../../../cssUtils/constants";

const DAY_DELTA_MIN = 0;
const DAY_DELTA_MAX = 5;

const ScheduleTemplateMessagePreset = ({
  schema,
  config,
  handleConfigChange,
  templates,
}) => {
  const day_delta_values = Array.from(
    { length: DAY_DELTA_MAX - DAY_DELTA_MIN + 1 },
    (_, i) => DAY_DELTA_MIN + i,
  );

  const getDayDeltaLabel = (dayDelta) => {
    if (dayDelta === 0) {
      return "Today";
    } else if (dayDelta === 1) {
      return "Tomorrow";
    } else if (dayDelta === -1) {
      return "Yesterday";
    } else if (dayDelta < 0) {
      return `${Math.abs(dayDelta)} days ago`;
    } else {
      return `${dayDelta} days from today`;
    }
  };

  return (
    <Stack spacing={3}>
      <Autocomplete
        options={templates || []}
        value={
          templates?.find(
            (template) => template?.template_id === config["template_id"],
          ) || ""
        }
        onChange={(e, newValue) =>
          handleConfigChange("template_id", newValue?.template_id)
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select Template"
            variant="outlined"
            required
          />
        )}
        getOptionLabel={(option) => option?.template_name || ""}
        renderOption={(props, option) => (
          <Stack
            {...props}
            key={option?.id}
            direction="column"
            gap={0.5}
            sx={{
              alignItems: "flex-start !important",
              textAlign: "left",
              width: "100%",
            }}
          >
            <Typography>{option?.template_name}</Typography>
            <Typography variant="body2" color={ColorsConstants.primaryGray40}>
              {option?.category[0]}
              {option?.category?.slice(1).toLowerCase()}
            </Typography>
          </Stack>
        )}
        isOptionEqualToValue={(option, value) =>
          option?.template_id === value?.template_id
        }
        noOptionsText="No Templates found"
      />

      <Autocomplete
        options={day_delta_values || []}
        value={config["day_delta"] || 0}
        multiple={false}
        onChange={(e, newValue) => handleConfigChange("day_delta", newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Schedule Date"
            variant="outlined"
            required={true}
            size="small"
            helperText="The date to schedule the message on. (Today = Day of execution)"
            required
          />
        )}
        getOptionLabel={(option) => getDayDeltaLabel(option)}
        renderOption={(props, option) => (
          <Stack
            {...props}
            key={option?.id}
            direction="column"
            gap={0.5}
            sx={{
              alignItems: "flex-start !important",
              textAlign: "left",
              width: "100%",
            }}
          >
            <Typography>{getDayDeltaLabel(option)}</Typography>
          </Stack>
        )}
        isOptionEqualToValue={(option, value) => option === value}
        noOptionsText="No day delta found"
      />

      <TextField
        fullWidth
        label={formatTitle("time")}
        type="time"
        placeholder={schema?.properties["time"]?.description || ""}
        value={config["time"] || ""}
        onChange={(e) => handleConfigChange("time", e.target.value)}
        required={true}
        sx={{
          "& .MuiOutlinedInput-root.Mui-focused fieldset": {
            borderColor: "primary.main",
          },
        }}
      />
    </Stack>
  );
};

export default ScheduleTemplateMessagePreset;
